<template>
  <div class="page" :class="type">
    <header class="header">
      <h1>{{ title }}</h1>
      <div>
        <i @click="back" class="cubeic-back"></i>
      </div>
      <div class="header-right">
        <slot name="right"></slot>
      </div>
    </header>
    <div class="wrapper">
      <section v-show="desc" class="desc">
        <slot name="desc">{{ desc }}</slot>
      </section>
      <main class="content">
        <slot name="content">{{ content }}</slot>
      </main>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    // false 时仅 $emit('back')，由父组件自行处理路由返回
    isDefaultBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    back () {
      if (this.isDefaultBack) {
        this.$emit('back')
        this.$router.back()
      } else {
        this.$emit('back')
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.page {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #efeff4;

  .header {
    position: relative;
    height: 88px;
    line-height: 88px;
    text-align: center;
    background-color: #ffffff;
    box-shadow: 0 2px 12px #ccc;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 5;

    h1 {
      font-size: 32px;
      font-weight: 700;
    }

    .cubeic-back {
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 30px;
      color: #4d8ee3;
    }

    .header-right {
      position: absolute;
      top: 0;
      right: 0;
      height: 88px;
      display: flex;
      align-items: center;
      padding-right: 10px;
    }
  }

  >.wrapper {
    height: calc(100% - 88px);
    overflow-x: hidden;
    overflow-y: auto;

    // -webkit-overflow-scrolling: touch
    .desc {
      padding: 20px;
      margin: 20px 0;
      line-height: 40px;
      font-size: 28px;
    }

    .content {
      background-color: white;
      overflow-y: auto;
      height: 100%;
    }
  }

  &.option-demo {
    .wrapper {
      background-color: $color-white;
    }

    .title {
      font-size: $fontsize-large;
      font-weight: 500;
      color: $color-dark-grey;
      padding: 30px;
      border-bottom: 2px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 30px;
    }

    .options {
      margin-bottom: 30px;
    }

    .option-list {
      .group {
        margin-bottom: 30px;
        border: 2px solid rgba(0, 0, 0, 0.1);
        border-radius: $radius-size-medium;
      }

      .item {
        height: 104px;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);

        &.sub {
          font-size: $fontsize-medium;
          background-color: $color-light-grey-opacity;

          &.first {
            box-shadow: 0 2px 2px 2px #eee inset;
          }

          &.last {
            border-bottom: none;
          }
        }
      }
    }

    .demo {
      margin-bottom: 30px;
    }

    .methods {
      .method-list {
        .group {
          margin-bottom: 30px;
          border: 2px solid rgba(0, 0, 0, 0.1);
          border-radius: $radius-size-medium;
        }

        .item, button {
          height: 80px;
          font-size: $fontsize-large;
        }

        .item {
          background-color: $color-active-light-gray;
          border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        }

        button {
          width: 100%;
          border-bottom-left-radius: $radius-size-medium;
          border-bottom-right-radius: $radius-size-medium;
          background-color: $color-orange;
          box-shadow: 0 0 0 2px $color-orange;
          border: none;
          outline: none;
          color: $color-white;
        }
      }
    }
  }
}

</style>
